import { useMemo } from 'react';

import { useScreenState } from '@gogame/screens';

import {
  trackerReducer,
  SET_BREAKDOWN_DIMENSIONS,
} from 'scenes/Trackers/Tracker/reducers';

import { ensurePeriodType } from './useFiltersWithPeriodType';

export const useTrackerData = () => {
  const screenState = useScreenState();

  const trackerData = useMemo(() => {
    const breakdownState = trackerReducer(screenState, {
      type: SET_BREAKDOWN_DIMENSIONS,
      payload:
        screenState.temporary?.breakdownPath || screenState.breakdownPath,
    });

    const {
      filtersCollection,
      drillPath,
      columns,
      dimensionSearchQuery,
      advancedFilters,
      tableSettings,
      breakdownPath,
      presentedRows,
    } = breakdownState.temporary || breakdownState;

    return {
      presentedRows,
      filtersCollection: ensurePeriodType(filtersCollection),
      drillPath,
      columns,
      dimensionSearchQuery,
      advancedFilters,
      tableSettings: {
        ...tableSettings,
        limit: undefined,
      },
      currentDimensionsCount: breakdownPath.length
        ? breakdownPath.length + 1
        : undefined,
    };
  }, [screenState]);

  return trackerData;
};
